// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.result-value {
  font-size: 34px;
}

.result-label {
  margin: 0 auto;
  width: 70%;
}

svg {
  height: 210px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/ui-components/charts/donut/donut.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".result-value {\n  font-size: 34px;\n}\n\n.result-label {\n  margin: 0 auto;\n  width: 70%;\n}\n\nsvg {\n  height: 210px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
